<template>
  <section
    class="container h-full max-w-full mx-auto px-4 sm:px-6 lg:px-8 pb-12 pt-5 md:pt-10 lg:pt-12 min-h-screen">
    <Titre textePrincipal="Nos derniers adoptés(es) pour la " texteAccentue="vie"
      :isSidebarOpen="isSidebarOpen" />
     <p class="mx-auto text-lg text-gray-500 lg:text-xl md:max-w-7xl mb-12 sm:mt-[-40px] px-10">Merci à tous ceux et celles qui ont choisi
      d’adopter un chat ou un chaton de notre groupe, leur offrant ainsi une seconde chance.</p>

    <div class="max-w-full flex flex-wrap flex-row justify-center items-stretch gap-6 mb-20">

      <CardAdoptes v-for="(card, index) in cards" :key="index"
        :imageSrc="card.imageSrc" :altText="card.altText" :imageTitle="card.imageTitle"
        :chatFemelleAdoptee="card.chatFemelleAdoptee || false"
        :chatMaleAdopte="card.chatMaleAdopte || false"
        :title="card.title"
        :reserved="card.reserved"
        :details="card.details"
        >
      </CardAdoptes>
    </div>

    <div class="container flex flex-wrap flex-row justify-center items-stretch gap-6 mb-10">
      <router-link to="/adoption" class="px-4 py-2 text-white bg-navigation hover:bg-primaire rounded-md" aria-label="Adoption" title="Adoption">
        Info adoption
      </router-link>
    </div>
  </section>

</template>

<script setup>
import Titre from '../composants/Titre.vue';
import CardAdoptes from '../composants/CardAdoptes.vue';
import { isSidebarOpen } from '../store/storeSideBar.js';

import { useListeChatsAdoptes } from '../composables/apiListeChats.js';
import { computed, onMounted } from 'vue';
const { listeChatsAdoptes, chargerListeChatsAdoptes } = useListeChatsAdoptes();

onMounted(() => {
  chargerListeChatsAdoptes();
});

const cards = computed(() => {
  const chatsArray = Array.isArray(listeChatsAdoptes.value)
    ? listeChatsAdoptes.value
    : Object.values(listeChatsAdoptes.value || {});

  return chatsArray.map(chat => {
    // Prépare le titre et les détails
    const title = `${chat.nom ?? ''}\u00A0\u00A0#${chat.no_identification ?? ''}`;
    const details = [
      chat.type
        ? `${chat.type} ${chat.type.toLowerCase() === 'femelle' ? 'née' : 'né'} ${chat.date_de_naissance || ''}`
        : '',
      chat.date_adoption ? `Adopté${chat.type && chat.type.toLowerCase() === 'femelle' ? 'e' : ''}:  ${chat.date_adoption}` : ''
    ].filter(Boolean);

    // Image déjà traitée dans l'API, sinon adapte ici si besoin 
    return {
      ...chat,
      title,
      details,
      imageSrc: chat.image,
      imageTitle: chat.nom,
      altText: chat.nom,
      chatFemelleAdoptee: chat.type && chat.type.toLowerCase() === 'femelle',
      chatMaleAdopte: chat.type && chat.type.toLowerCase() === 'mâle',
    };
  });
});

</script>

<style scoped> </style>